import productFragment from '../fragments/productFragment'

export default `
query getProducts($first: Int, $after: String) {
  getProducts(first: $first, after: $after) {
    items {
      ${productFragment}
    }
    nextToken
  }
}
`
